/** Most images a card carousel offers; the detail view shows the rest. */
export const MAX_CARD_IMAGES = 5;

export function clampSlide(index: number, count: number): number {
  if (count <= 0) return 0;
  return Math.min(Math.max(index, 0), count - 1);
}

/** The slide a scroll position has settled nearest to. */
export function slideFromScroll(
  scrollLeft: number,
  slideWidth: number,
  count: number,
): number {
  if (slideWidth <= 0) return 0;
  return clampSlide(Math.round(scrollLeft / slideWidth), count);
}

/**
 * Slides whose image should be in the DOM: the current one and its
 * neighbours, so the next swipe has something loaded without every card in
 * the grid fetching all of its images up front.
 */
export function slidesToMount(
  current: number,
  count: number,
  radius = 1,
): Set<number> {
  const mounted = new Set<number>();
  for (let i = current - radius; i <= current + radius; i++) {
    if (i >= 0 && i < count) mounted.add(i);
  }
  return mounted;
}
